import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      if (r?.suppressedAuth || !r?.data) {
        setUser(false);
        return null;
      }
      setUser(r.data);
      return r.data;
    } catch { setUser(false); return null; }
  }, []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data); return data;
  };
  const register = async (email, password, name, marketingConsent = false) => {
    const { data } = await api.post("/auth/register", { email, password, name, marketing_consent: marketingConsent });
    setUser(data); return data;
  };
  const verifyEmail = async (code) => {
    const { data } = await api.post("/auth/verify-email", { code });
    if (data.welcome_coupon) {
      try { localStorage.setItem("welcome_coupon", data.welcome_coupon); } catch {}
    }
    setUser((u) => (u ? { ...u, email_verified: true } : u));
    return data;
  };
  const resendVerification = async () => {
    const { data } = await api.post("/auth/resend-verification");
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, verifyEmail, resendVerification, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
